<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs">
        <use href="assets/icons-ui.svg#cross-closed"></use>
    </svg>
</button>
<h2 modal-title>
    <span *ngIf="data.coverage_title === coverageIdEnum.WA">
        Wettelijke aansprakelijkheid ({{ data.coverage_title }})
    </span>
    <span *ngIf="data.coverage_title !== coverageIdEnum.WA">{{ data.coverage_title }}</span>
</h2>
<div modal-content>
    <ng-container
        *ngIf="
            [
                coverageIdEnum.WA,
                coverageIdEnum.BeperktCasco,
                coverageIdEnum.BeperktCascoExtra,
                coverageIdEnum.Allrisk,
            ].includes(data.coverage_id)
        "
    >
        <ins-car-base-coverage-info [coverageId]="data.coverage_id"></ins-car-base-coverage-info>
    </ng-container>
    <ng-container *ngIf="[coverageIdEnum.FietsDiefstal, coverageIdEnum.FietsAllrisk].includes(data.coverage_id)">
        <ins-bicycle-base-coverage-info [coverageId]="data.coverage_id"></ins-bicycle-base-coverage-info>
    </ng-container>
    <ng-container *ngIf="[coverageIdEnum.CaravanAllriskEU, coverageIdEnum.CaravanAllriskNL].includes(data.coverage_id)">
        <ins-caravan-coverage-info-modal [coverageId]="data.coverage_id"></ins-caravan-coverage-info-modal>
    </ng-container>
    <ng-container
        *ngIf="
            [coverageIdEnum.BromAllrisk, coverageIdEnum.BromWA, coverageIdEnum.BromBeperktCasco].includes(
                data.coverage_id
            )
        "
    >
        <ins-moped-base-coverage-info [coverageId]="data.coverage_id"></ins-moped-base-coverage-info>
    </ng-container>
    <ng-container
        *ngIf="
            [coverageIdEnum.MotorAllrisk, coverageIdEnum.MotorWA, coverageIdEnum.MotorOpStal].includes(data.coverage_id)
        "
    >
        <ins-motor-base-coverage-info [coverageId]="data.coverage_id"></ins-motor-base-coverage-info>
    </ng-container>
</div>
<div modal-actions alignment="between"></div>
